// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandDetailsMobileFooter_container__0NDpV","mainText":"BrandDetailsMobileFooter_mainText__Heo3Q","backgroundImage":"BrandDetailsMobileFooter_backgroundImage__t4uW6"};